import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { EditorState, convertToRaw, ContentState } from 'draft-js'
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { DEFAULT_IMAGE_URL } from '../../utils/contrains'

export default class RichTextEditor extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  

    state = {
        editorState: EditorState.createEmpty(),
    }

    static propTypes = {
        edit_input_richtext: PropTypes.string
    }

    constructor(props) {
        super(props)

        const text = this.props.edit_input_richtext
        if (text) {
            const contentBlock = htmlToDraft(text)
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
            const editorState = EditorState.createWithContent(contentState)
            this.state = { editorState }
        } else {
            this.state = { editorState: EditorState.createEmpty() }
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    onEditorStateChange = (editorState) => {
        this.setState({
            editorState,
        });
    }

    // 操作互動處理 //////////////////////////////////////////////

    uploadImageCallBack = (file) => {
        return new Promise(
            (resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', DEFAULT_IMAGE_URL + "/api/Appendix/AddFile");
                //xhr.setRequestHeader('Authorization', 'Client-ID XXXXX');
                const data = new FormData();
                data.append('file', file);
                xhr.send(data);
                xhr.addEventListener('load', () => {
                    const response = JSON.parse(xhr.responseText);
                    //console.log('response', response)
                    const url = response.url
                    resolve({ data: { link: DEFAULT_IMAGE_URL + url } });
                });
                xhr.addEventListener('error', () => {
                    const error = JSON.parse(xhr.responseText);
                    reject(error);
                });
            }
        );
    }

    // 外部接收方法 ////////////////////////////////////   

    // 提供給父組件(product-modify)使用
    output_text = () => { return draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())) }

    /////////////////////////////////////////////////////////////

    render() {
        const { editorState } = this.state
        return (
            <div>
                <Editor
                    editorState={editorState}
                    editorStyle={{ border: '1px solid gray', minHeight: 150, paddingLeft: 10,backgroundColor: 'LightYellow' }}
                    onEditorStateChange={this.onEditorStateChange}
                    localization={{
                        locale: 'zh_tw',
                    }}
                    toolbar={{
                        image: {
                            urlEnabled: true,
                            uploadEnabled: true,
                            alignmentEnabled: true,   // 是否顯示排列 相當於text-align
                            uploadCallback: this.uploadImageCallBack,
                            previewImage: true,
                            inputAccept: 'image/*',
                            alt: { present: false, mandatory: false, previewImage: true }
                        },
                    }}
                />
            </div>
        )
    }
}